import { MessageCircle } from "lucide-react";
import { Seo } from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { LogoMark } from "../components/Logo";
import { waLink, WA_DEFAULT_MSG, IMAGES } from "../lib/site";

export default function AboutPage() {
  return (
    <main className="bg-[#08090C] pt-24 sm:pt-32 pb-20 min-h-screen">
      <Seo
        title="من نحن | حساسات كفرات الرياض"
        description="حساسات كفرات الرياض — منصة متخصصة في حساسات ضغط الإطارات TPMS تهدف لتسهيل وصول العملاء إلى الحساس المناسب لسياراتهم في الرياض."
        path="/about"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <LogoMark size={56} />
              <span className="font-mono text-xs tracking-[0.25em] text-slate-500 uppercase">
                Riyadh Tire Sensors
              </span>
            </div>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tight mb-6">
              من نحن
            </h1>
            <p className="text-slate-300 leading-relaxed text-base sm:text-lg mb-5">
              حساسات كفرات الرياض منصة متخصصة في حساسات ضغط الإطارات TPMS،
              وتهدف إلى تسهيل وصول العملاء إلى الحساس المناسب لسياراتهم، مع
              توفير معلومات واضحة عن البرمجة والفحص والاستبدال والتوافق مع
              أنظمة السيارات المختلفة.
            </p>
            <p className="text-slate-400 leading-relaxed text-base mb-8">
              تواصل معنا لمعرفة الخيارات المناسبة لسيارتك.
            </p>
            <a
              href={waLink(WA_DEFAULT_MSG)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-whatsapp-btn"
              className="inline-flex items-center gap-2.5 bg-emerald-600 hover:bg-emerald-500 text-white font-bold px-7 py-3.5 rounded-full shadow-[0_4px_24px_rgba(16,185,129,0.4)] transition-all active:scale-[0.97]"
            >
              <MessageCircle size={19} />
              تواصل عبر واتساب
            </a>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative rounded-3xl overflow-hidden border border-white/10">
              <img
                src={IMAGES.workshop}
                alt="مركز صيانة وبرمجة سيارات حديث في الرياض"
                className="w-full h-[320px] sm:h-[420px] object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#08090C]/80 via-transparent to-transparent" />
            </div>
          </Reveal>
        </div>
      </div>
    </main>
  );
}
